import dayjs from 'dayjs'
export default function dateTime(value) {
  if (!value) {
    return ''
  } else {
    return dayjs(value).format('MM/DD/YYYY LTS')
  }
}
